import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Index';
import SolucoesEmEvidencia from './pages/solucoesEmEvidencia/Index';
import SobreNos from './pages/sobreNos/Index';
import Socios from './pages/socios/Index';

function App() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/SolucoesEmEvidencia" element={<SolucoesEmEvidencia />} />
			<Route path="/SobreNos" element={<SobreNos />} />
			<Route path="/Socios" element={<Socios />} />
		</Routes>
	);
}

export default App;
